import { DEFAULT_ACTIVITY_SORTING_TYPE } from '@/controllers/Activity';
import { ActivityStatus } from '@/types';

export enum TabName {
  Home = 'Home',
  Leads = 'Leads',
  Jobs = 'Jobs',
  Orders = 'Orders',
  Projects = 'Projects',
  Reports = 'Reports',
}

export enum TabType {
  Home = 0,
  Leads = 1,
  Orders = 2,
  Projects = 3,
  Reports = 4,
}

export const TabNames: Readonly<Record<TabType, TabName>> = Object.freeze({
  [TabType.Home]: TabName.Home,
  [TabType.Leads]: TabName.Leads,
  [TabType.Orders]: TabName.Orders,
  [TabType.Projects]: TabName.Projects,
  [TabType.Reports]: TabName.Reports,
});

export const createDefaultActivityFilters = () => ({
  type: 0,
  statuses: [
    ActivityStatus.New,
    // ActivityStatus.Disqualified - Excluded by default
    ActivityStatus['Generating Proposal'],
    ActivityStatus['Proposal Ready'],
    // ActivityStatus.Lost - Excluded by default
    ActivityStatus['Ready to Order'],
    ActivityStatus['Order Submitted'],
    ActivityStatus['Order Initiated'],
    ActivityStatus['Order Received'],
    ActivityStatus['Order Shipped'],
    // ActivityStatus['Order Canceled'] - Excluded by default
    ActivityStatus['Order Delivered'],
  ],
  sortingType: DEFAULT_ACTIVITY_SORTING_TYPE,
  searchQuery: '',
  starredOnly: false,
});
